module.exports = __webpack_public_path__ + "img/sparkles-regular.09224538.svg";